{
  "__localization_test_string": "Вы достигли максимального количества посещений этого провайдера за {{time_period}}. В следующий раз вы можете посетить этого провайдера, начиная с {{start_date}}.",
  "app_name": "Plentiful",
  "app_button_ok": "ХОРОШО",
  "app_button_cancel": "Отмена",
  "app_button_yes": "Да",
  "app_button_no": "Нет",
  "app_button_confirm": "Подтверждать",
  "app_button_try_again": "Попробуйте еще раз",
  "rate_the_app": "Оценить Plentiful",
  "app_textview_somethingwentwrong": "Что-то пошло не так!\nПожалуйста, попробуйте еще раз",
  "app_button_logout": "Выйти",
  "app_today": "Сегодня",
  "app_dialog_clarify_prompt": "Уверены ли вы?",
  "app_personal_edittext_phone": "Телефонный номер",
  "app_personal_edittext_dob": "Дата рождения (необязательно)",
  "app_personal_edittext_firstname": "Имя",
  "app_personal_edittext_lastname": "Фамилия",
  "app_personal_edittext_zipcode": "Почтовый индекс",
  "app_pantrykind_food": "Пищевая кладовая",
  "app_servicekind_reservations": "Оговорка",
  "app_servicekind_line": "Линия",
  "distribution_schedule": "Расписание раздачи",
  "service_type_no_digital_options": "Только очередь",
  "service_type_reservation_inline": "Бронирования",
  "service_type_allows_pre_registration": "Разрешает Предварительную Регистрацию",
  "app_locationnotavailable": "Место не доступно",
  "app_generalerror": "Ошибка",
  "app_dialog_loading": "Загрузка. Пожалуйста подождите…",
  "app_dialog_sms_code_title": "SMS-код",
  "app_dialog_sms_code_button_send_new_code": "Отправить новый код",
  "app_release_id": "Идентификатор выпуска приложения",
  "sms_disclaimer": "Могут применяться тарифы на сообщения и данные. Отправьте STOP для отказа.",
  "fragment_registration_language_textview_title": "Выберите предпочитаемый язык, чтобы начать",
  "fragment_registration_language_button_next": "Следующий",
  "fragment_registration_family_textview_title": "Расскажите нам о своей семье",
  "fragment_registration_family_textview_adults": "Количество взрослых (18–{{senior_age_threshold_minus_one}})",
  "fragment_registration_family_textview_children": "Количество детей (до 18 лет)",
  "fragment_registration_family_textview_seniors": "Количество пожилых людей ({{senior_age_threshold}}+)",
  "fragment_registration_family_textview_notetitle": "Примечание:",
  "fragment_registration_family_textview_notecontent": "Помогите нам лучше обслуживать вас, предоставив данные о вашем домохозяйстве. Обратите внимание: не включайте себя в число членов домохозяйства, перечисленных выше.",
  "fragment_registration_family_button_back": "Назад",
  "fragment_registration_family_button_next": "Следующий",
  "fragment_registration_personal_textview_title": "Добро пожаловать в ваш Plentiful Profile",
  "fragment_registration_personal_button_back": "Назад",
  "fragment_registration_personal_button_finish": "Заканчивать",
  "fragment_main_tabitem_pantrymap": "карта",
  "fragment_main_tabitem_pantrylist": "Список",
  "fragment_main_bottombar_pantries": "Палки",
  "fragment_main_bottombar_visits": "Визиты",
  "fragment_main_bottombar_messages": "Сообщения",
  "fragment_main_bottombar_profile": "Профиль",
  "cell_pantry_short_visit_date": "Вы собираетесь",
  "fragment_pantrydetail_button_changetime": "Время изменения",
  "fragment_pantrydetail_textview_amenities": "Удобства",
  "fragment_pantrydetail_textview_conditions": "Условия",
  "fragment_pantrydetail_textview_notes": "Кладовые ноты",
  "fragment_pantrydetail_edittext_message": "Сообщение…",
  "fragment_pantrydetail_button_createreservation": "Запланировать визит",
  "fragment_pantrydetail_button_schedulevisit": "запланировать визит",
  "dialog_visittime_textview_nodatesavailable": "Даты не доступны",
  "fragment_visitlist_textview_title": "Визиты",
  "fragment_visitlist_textview_zero": "Это где вы можете управлять вашим предстоящим временем обслуживания. Найдите кладовую, чтобы запланировать посещение!",
  "fragment_messagethreadlist_textview_title": "Сообщения",
  "fragment_messagethreadlist_textview_zero": "Пока обновлений нет!\nЧтобы подписаться на обновления, перейдите на страницу сведений о вашей любимой кладовой и включите опцию «Получать обновления из этой кладовой» в нижней части страницы.",
  "fragment_profile_textview_title": "Профиль",
  "fragment_profile_button_savechanges": "Сохранить изменения",
  "fragment_profile_textview_personaldetails": "Личная информация",
  "fragment_profile_textview_language": "Язык",
  "fragment_profile_textview_notifications": "Уведомления",
  "fragment_profile_switch_receivenotifications": "Push-уведомления",
  "receive_notifications_helper": "Получайте оповещения на вашем устройстве",
  "fragment_profile_textview_servicedetails": "Сервисные детали",
  "fragment_profile_switch_pickupfood": "Я поручил кому-то другому забрать мою еду",
  "fragment_profile_edittext_pickupname": "Имя и фамилия представителя службы самовывоза",
  "fragment_profile_edittext_pickupphone": "Номер телефона представителя службы выдачи",
  "textview_baby_supplies": "Для скольких детей вам нужны детские товары (подгузники, салфетки, смесь)",
  "fragment_profile_textview_emergencycontact": "Экстренный контакт",
  "fragment_profile_edittext_emergencyname": "Имя и фамилия контактного лица для экстренных случаев",
  "fragment_profile_edittext_emergencyphone": "Контактный телефон для экстренных случаев",
  "aiq_validation_error_regex_telephone_us": "Номер телефона имеет неверный формат",
  "fragment_profile_textview_changepersonalinfo": "Эта информация может быть обновлена ​​в любой в изобилии продовольствия.",
  "fragment_profile_edittext_feedback": "Обратная связь…",
  "fragment_profile_toast_feedbacksent": "Отзыв отправлена",
  "baby_supplies": "Детские принадлежности",
  "household_size": "Размер семьи",
  "food_pickup": "Самовывоз еды",
  "emergency_contact": "Экстренный контакт",
  "dialog_app_update_title": "Обновление доступно",
  "dialog_app_update_message": "Следующая версия приложения доступна в Google Play Store!",
  "dialog_app_update_button_openplaystore": "Открытый игровой магазин",
  "app_invalid_error": "Неверный",
  "no_pantries_available": "Результаты не найдены. Попробуйте выполнить поиск с другим названием кладовой или очистите поле поиска и переместите или уменьшите масштаб карты, чтобы исследовать области с изобилием кладовых.",
  "visit_served": "служил",
  "visit_not_served": "не служил",
  "visit_no_show": "Вы не появились",
  "visit_group": "Вы в группе {{group_number}}, заходите {{time}}",
  "visit_pre_registered": "Вы предварительно зарегистрированы. Встаньте в ряд между {{from_time}} - {{end_time}}",
  "pick_visit_time": "Выберите время посещения",
  "received_service_on": "Вы посетили",
  "service_starts_at": "Сервис начинается",
  "cancel_visit": "Отменить посещение",
  "confirm_cancel_visit": "Вы уверены, что хотите отменить свой визит?",
  "yes_cancel": "Да, отменить",
  "send": "Отправлять",
  "reservations_available": "Получайте обновления из этой кладовой",
  "report_location_issue": "Сообщить о проблеме с этим местоположением",
  "feeding_america_network_member": "Часть сети Feeding America",
  "feeding_america_find_food_link": "Посетите сайт продовольственного банка",
  "registration_intro": "Добро пожаловать в Plentiful! Мы здесь, чтобы помочь вам найти продовольственные склады рядом с вами.",
  "app_personal_edittext_enter_phone": "Введите свой номер телефона",
  "code_sent_to": "СМС-код для входа был отправлен на адрес",
  "account_created": "Аккаунт создан",
  "get_started": "Давайте начнем!",
  "additional_details": "Дополнительная информация",
  "your_qr_code": "Ваш плести",
  "id_number": "идентификационный номер",
  "personal_details_extra": "Личная информация и предпочтения",
  "settings": "Настройки",
  "settings_extra": "Настройки языка и уведомления",
  "not_verified": "Еще не проверено",
  "must_be_reverified_by": "Должен быть почитается",
  "last_verified_on": "В прошлый раз подтвержден",
  "at": "в",
  "no_visit_options_available": "На данный момент для вас нет доступных вариантов посещения. Пожалуйста, проверьте состояние кладовой или свяжитесь с кладовой.",
  "need_help": "Нужна помощь?",
  "email": "Эл. адрес",
  "terms_conditions": "Пользовательское Соглашение",
  "privacy_policy": "Конфиденциальность",
  "updates": "Обновления",
  "family_details": "Подробности о домашнем хозяйстве",
  "welcome_to_plentiful": "Добро пожаловать в обильные!",
  "enter_email_phone": "Регистрация позволяет вам делать заказы и получать обновления о пунктах выдачи продуктов, которые вы посещаете.\nЕсли вы зарегистрировались в пункте выдачи продуктов, используйте тот же номер телефона или адрес электронной почты. \nНужна помощь? Свяжитесь с нами по адресу support@plentiful.org",
  "email_or_phone": "Номер мобильного телефона или адрес электронной почты",
  "email_address": "Адрес электронной почты",
  "enter_email": "Введите адрес электронной почты",
  "address": "Адрес",
  "email_invalid": "Адрес электронной почты недействителен",
  "no_sms_enabled_phone": "Номер телефона не может принимать текстовые сообщения",
  "verification_email_sent": "Проверка электронного письма отправлено!",
  "check_verification_email": "Проверьте свою электронную почту и нажмите кнопку внутри, чтобы подтвердить свою учетную запись.",
  "email_verification_sent": "Мы отправили вам электронное письмо. Нажмите кнопку в письме, чтобы подтвердить свой адрес электронной почты.",
  "email_address_purpose": "получать напоминания о посещениях и важные обновления от Plentiful",
  "sign_up": "Зарегистрироваться",
  "sign_in": "Войти",
  "continue": "Продолжать",
  "create_password": "Придумайте пароль",
  "enter_password": "Пожалуйста, введите свой пароль для входа",
  "password_info_box": "Если вы забыли свой пароль или зарегистрировались в кладовой без установки пароля, воспользуйтесь приведенными ниже вариантами, чтобы войти в систему с помощью магии или сбросить пароль.",
  "reset_password": "Сброс пароля",
  "password": "Пароль",
  "eight_characters": "Не менее 8 символов",
  "one_special_character": "Как минимум 1 специальный персонаж",
  "one_number": "по крайней мере, один номер",
  "submit": "Представлять на рассмотрение",
  "send_magic_link": "Отправить волшебную ссылку",
  "magic_link_sent": "Волшебная ссылка уже в пути к вашему почтовому ящику.",
  "confirm_magic_link_login": "Подтвердить волшебную ссылку Войти",
  "sign_in_another_way": "Войти по-другому",
  "enter_phone": "пожалуйста введите ваш номер телефона",
  "skip": "Пропускать",
  "optional": "необязательный",
  "enter_activation_code": "Пожалуйста, введите свой код входа",
  "activation_code": "Код входа",
  "accept_eula": "Я прочитал и согласен с Условиями использования и конфиденциальности",
  "email_verified": "Проверено электронная почта",
  "email_verified_details": "Ваш адрес электронной почты теперь подтвержден.",
  "do_not_ask_again": "Не спрашивай снова.",
  "email_in_use": "У нас уже есть аккаунт, связанный с этим по электронной почте. Пожалуйста, используйте другой адрес электронной почты",
  "reset_password_text": "Пожалуйста, введите ваше письмо, чтобы сбросить пароль",
  "reset_password_sent": "Сбросить пароль отправлять электронную почту!",
  "reset_password_sent_text": "Если у нас есть учетная запись в файле для {{email}}, мы отправили ссылку для сброса пароля,",
  "dob_required": "Дата рождения",
  "please_verify": "Пожалуйста, проверьте телефон или адрес электронной почты в своем профиле",
  "open_profile": "Открыть профиль",
  "send_another_verification_email": "Отправить еще одну проверку электронной почты",
  "need_to_change_email": "Если вам нужно изменить свой адрес электронной почты, свяжитесь с нами по адресу support@plentifulapp.com.",
  "need_to_change_email_or_phone": "Если вам нужно изменить свой адрес электронной почты или номер телефона, свяжитесь с нами по адресу support@plentifulapp.com.",
  "need_to_change_phone": "Если вам нужно изменить номер вашего телефона, пожалуйста, свяжитесь с Support@plentifulapp.com или посетите кладовую.",
  "email_subscription": "По электронной почте подписка",
  "email_subscribed": "Электронная почта подписана",
  "email_unsubscribed": "Электронная почта отписывается",
  "email_subscribed_text": "Вы теперь подписались {{email}} в обильные письма",
  "email_unsubscribed_text": "Теперь вы не отписались {{email}} из обильных писем",
  "here_to_subscribe": "Нажмите здесь, чтобы подписаться на обильные электронные письма",
  "here_to_unsubscribe": "Нажмите здесь, чтобы отписаться от обильных писем",
  "unsubscribe": "Отписаться",
  "subscribe": "Подписывайся",
  "open_profile_text": "Нажмите здесь, чтобы перейти в свой профиль",
  "sign_in_text": "Нажмите здесь, чтобы войти",
  "phone_assigned": "Этот номер телефона уже используется. Введите другой номер телефона или вернитесь и войдите в систему с этим номером телефона.",
  "email_subscribe": "Email-обновления",
  "email_subscribe_helper": "Письма от кладовых, которые вы посещаете, и от Plentiful",
  "message_preferences": "Настройки сообщений",
  "message_preferences_description": "Как вы хотите получать напоминания о визитах и обновления?",
  "message_method_option_0": "Email и уведомления приложения",
  "message_method_option_1": "Предпочитать SMS",
  "message_method_helper_add_phone": "Добавьте номер телефона для получения SMS",
  "message_method_helper_sms_opt_in": "Отправьте 'START' на PANTRY (726-879), чтобы снова получать SMS",
  "message_method_helper_add_email": "Добавьте email для получения сообщений",
  "message_method_helper_email_unsub": "Вы отписались от email. Обновите настройки email для получения сообщений.",
  "message_method_helper_add_push": "Скачайте мобильное приложение для получения push-уведомлений",
  "message_method_helper_enable_push": "Включите уведомления в настройках устройства для получения push-уведомлений",
  "password_error": "Неправильный пароль. Попробуйте еще раз, сбросьте свой пароль или войдите в другой способ",
  "action_required": "Требуются действия",
  "otp_error": "Код не может быть проверен",
  "show_more": "Показать больше",
  "pre_registration": "Постановка на учет",
  "show_less": "Показывай меньше",
  "reschedule": "Перенесение",
  "view_pantry": "Посмотреть подробности о кладовой",
  "next_service_on": "Следующая служба включена",
  "add_birthday": "Добавьте свой день рождения, чтобы разблокировать Plenti-Pass",
  "birthday_required": "Этот пропуск можно использовать для быстрой и легкой регистрации в пунктах выдачи продуктов.",
  "missed_reservation_on": "Вы пропустили ваше бронирование на",
  "delete_account": "Удалить аккаунт",
  "delete_explain": "Вы уверены, что хотите удалить свою учетную запись? Это отменит все предстоящие посещения кладовой и удалит вашу учетную запись. Чтобы использовать Plentiful, вам нужно будет зарегистрироваться еще раз.",
  "yes_delete": "Да, удалить",
  "no_cancel": "Нет, отменить",
  "select_visit_reschedule": "Выберите визит, который вы хотите перенести",
  "select_visit_cancel": "Выберите визит, который вы хотите отменить",
  "search_pantries": "Поисковые клаоны",
  "please_sign_in_or_up": "Вам нужен обильный счет, чтобы продолжить. Встрях полностью свободно использовать.",
  "sign_in_or_up": "Войдите или зарегистрируйтесь, чтобы продолжить",
  "country_of_birth_option_AF": "Афганистан",
  "country_of_birth_option_AX": "Аландские острова",
  "country_of_birth_option_AL": "Албания",
  "country_of_birth_option_DZ": "Алжир",
  "country_of_birth_option_AS": "американское Самоа",
  "country_of_birth_option_AD": "Андорра",
  "country_of_birth_option_AO": "Ангола",
  "country_of_birth_option_AI": "Ангилья",
  "country_of_birth_option_AQ": "Антарктида",
  "country_of_birth_option_AG": "Антигуа и Барбуда",
  "country_of_birth_option_AR": "Аргентина",
  "country_of_birth_option_AM": "Армения",
  "country_of_birth_option_AW": "Аруба",
  "country_of_birth_option_AU": "Австралия",
  "country_of_birth_option_AT": "Австрия",
  "country_of_birth_option_AZ": "Азербайджан",
  "country_of_birth_option_BS": "Багамские острова",
  "country_of_birth_option_BH": "Бахрейн",
  "country_of_birth_option_BD": "Бангладеш",
  "country_of_birth_option_BB": "Барбадос",
  "country_of_birth_option_BY": "Беларусь",
  "country_of_birth_option_BE": "Бельгия",
  "country_of_birth_option_BZ": "Белизны",
  "country_of_birth_option_BJ": "Бенин",
  "country_of_birth_option_BM": "Бермудские острова",
  "country_of_birth_option_BT": "Бутан",
  "country_of_birth_option_BO": "Боливия",
  "country_of_birth_option_BA": "Босния и Герцеговина",
  "country_of_birth_option_BW": "Ботсвана",
  "country_of_birth_option_BV": "Остров Буве",
  "country_of_birth_option_BR": "Бразилия",
  "country_of_birth_option_IO": "Британская территория Индийского океана",
  "country_of_birth_option_BN": "Бруней-Даруссалам",
  "country_of_birth_option_BG": "Болгария",
  "country_of_birth_option_BF": "Буркина-Фасо",
  "country_of_birth_option_BI": "Бурунди",
  "country_of_birth_option_KH": "Камбоджа",
  "country_of_birth_option_CM": "Камерун",
  "country_of_birth_option_CA": "Канада",
  "country_of_birth_option_CV": "Кабо-Верде",
  "country_of_birth_option_KY": "Каймановы острова",
  "country_of_birth_option_CF": "Центрально-Африканская Республика",
  "country_of_birth_option_TD": "Чад",
  "country_of_birth_option_CL": "Чили",
  "country_of_birth_option_CN": "Китай",
  "country_of_birth_option_CX": "Остров Рождества",
  "country_of_birth_option_CC": "Кокосовые (килинговые) острова",
  "country_of_birth_option_CO": "Колумбия",
  "country_of_birth_option_KM": "Comoros.",
  "country_of_birth_option_CG": "Конго",
  "country_of_birth_option_CD": "Конго, Демократическая Республика",
  "country_of_birth_option_CK": "Острова Кука",
  "country_of_birth_option_CR": "Коста-Рика",
  "country_of_birth_option_CI": "Берег Слоновой Кости",
  "country_of_birth_option_HR": "Хорватия",
  "country_of_birth_option_CU": "Куба",
  "country_of_birth_option_CY": "Кипр",
  "country_of_birth_option_CZ": "Чешская Республика",
  "country_of_birth_option_DK": "Дания",
  "country_of_birth_option_DJ": "Джибути",
  "country_of_birth_option_DM": "Доминика",
  "country_of_birth_option_DO": "Доминиканская Республика",
  "country_of_birth_option_EC": "Эквадор",
  "country_of_birth_option_EG": "Египет",
  "country_of_birth_option_SV": "Сальвадор",
  "country_of_birth_option_GQ": "Экваториальная Гвинея",
  "country_of_birth_option_ER": "Эритрея",
  "country_of_birth_option_EE": "Эстония",
  "country_of_birth_option_ET": "Эфиопия",
  "country_of_birth_option_FK": "Фолклендские острова (Мальвинас)",
  "country_of_birth_option_FO": "Фарерские острова",
  "country_of_birth_option_FJ": "Фиджи",
  "country_of_birth_option_FI": "Финляндия",
  "country_of_birth_option_FR": "Франция",
  "country_of_birth_option_GF": "Гвиана Французская",
  "country_of_birth_option_PF": "Французская Полинезия",
  "country_of_birth_option_TF": "Французские Южные территории",
  "country_of_birth_option_GA": "Габон",
  "country_of_birth_option_GM": "Гамбия",
  "country_of_birth_option_GE": "Грузия",
  "country_of_birth_option_DE": "Германия",
  "country_of_birth_option_GH": "Гана",
  "country_of_birth_option_GI": "Гибралтар",
  "country_of_birth_option_GR": "Греция",
  "country_of_birth_option_GL": "Гренландии",
  "country_of_birth_option_GD": "Гренада",
  "country_of_birth_option_GP": "Гваделупа",
  "country_of_birth_option_GU": "Гуам",
  "country_of_birth_option_GT": "Гватемала",
  "country_of_birth_option_GG": "Гернси",
  "country_of_birth_option_GN": "Гвинея",
  "country_of_birth_option_GW": "Гвинея-Бисау",
  "country_of_birth_option_GY": "Гайана",
  "country_of_birth_option_HT": "Гаити",
  "country_of_birth_option_HM": "Слышал остров и Макдональдские острова",
  "country_of_birth_option_VA": "Святой см. (Город Ватикан)",
  "country_of_birth_option_HN": "Гондурас",
  "country_of_birth_option_HK": "Гонконг",
  "country_of_birth_option_HU": "Венгрия",
  "country_of_birth_option_IS": "Исландия",
  "country_of_birth_option_IN": "Индия",
  "country_of_birth_option_ID": "Индонезия",
  "country_of_birth_option_IR": "Иран, Исламская Республика",
  "country_of_birth_option_IQ": "Ирак",
  "country_of_birth_option_IE": "Ирландия",
  "country_of_birth_option_IM": "Остров Мэн",
  "country_of_birth_option_IL": "Израиль",
  "country_of_birth_option_IT": "Италия",
  "country_of_birth_option_JM": "Ямайка",
  "country_of_birth_option_JP": "Япония",
  "country_of_birth_option_JE": "Джерси",
  "country_of_birth_option_JO": "Иордания",
  "country_of_birth_option_KZ": "Казахстан",
  "country_of_birth_option_KE": "Кения",
  "country_of_birth_option_KI": "Kiribati.",
  "country_of_birth_option_KP": "Корея, Демократическая Народная Республика",
  "country_of_birth_option_KR": "Республика Корея",
  "country_of_birth_option_KW": "Кувейт",
  "country_of_birth_option_KG": "Кыргызстан",
  "country_of_birth_option_LA": "Лаосская Народная Демократическая Республика",
  "country_of_birth_option_LV": "Латвия",
  "country_of_birth_option_LB": "Ливан",
  "country_of_birth_option_LS": "Лесото",
  "country_of_birth_option_LR": "Либерия",
  "country_of_birth_option_LY": "Ливийская арабская джамахирия",
  "country_of_birth_option_LI": "Лихтенштейн",
  "country_of_birth_option_LT": "Литва",
  "country_of_birth_option_LU": "Люксембург",
  "country_of_birth_option_MO": "Макао",
  "country_of_birth_option_MK": "Македония, бывшая Югославская Республика",
  "country_of_birth_option_MG": "Мадагаскар",
  "country_of_birth_option_MW": "Малави",
  "country_of_birth_option_MY": "Малайзия",
  "country_of_birth_option_MV": "Мальдивы",
  "country_of_birth_option_ML": "Мали",
  "country_of_birth_option_MT": "Мальта",
  "country_of_birth_option_MH": "Маршалловы острова",
  "country_of_birth_option_MQ": "Мартиника",
  "country_of_birth_option_MR": "Мавритания",
  "country_of_birth_option_MU": "Маврикий",
  "country_of_birth_option_YT": "Майотта",
  "country_of_birth_option_MX": "Мексика",
  "country_of_birth_option_FM": "Микронезия, Федеративные состояния",
  "country_of_birth_option_MD": "Молдова",
  "country_of_birth_option_MC": "Монако",
  "country_of_birth_option_MN": "Монголия",
  "country_of_birth_option_MS": "Монтсеррат",
  "country_of_birth_option_MA": "Марокко",
  "country_of_birth_option_MZ": "Мозамбик",
  "country_of_birth_option_MM": "Мьянмар",
  "country_of_birth_option_NA": "Намибия",
  "country_of_birth_option_NR": "Науру",
  "country_of_birth_option_NP": "Непал",
  "country_of_birth_option_NL": "Нидерланды",
  "country_of_birth_option_AN": "Нидерландские Антильские острова",
  "country_of_birth_option_NC": "Новая Каледония",
  "country_of_birth_option_NZ": "Новая Зеландия",
  "country_of_birth_option_NI": "Никарагуа",
  "country_of_birth_option_NE": "Нигер",
  "country_of_birth_option_NG": "Нигерия",
  "country_of_birth_option_NU": "Ничтожество",
  "country_of_birth_option_NF": "Норфолк",
  "country_of_birth_option_MP": "Северные Марианские острова",
  "country_of_birth_option_NO": "Норвегия",
  "country_of_birth_option_OM": "Оман",
  "country_of_birth_option_PK": "Пакистан",
  "country_of_birth_option_PW": "Палау",
  "country_of_birth_option_PS": "Палестинская территория, оккупированная",
  "country_of_birth_option_PA": "Панама",
  "country_of_birth_option_PG": "Папуа - Новая Гвинея",
  "country_of_birth_option_PY": "Парагвай",
  "country_of_birth_option_PE": "Перу",
  "country_of_birth_option_PH": "Филиппины",
  "country_of_birth_option_PN": "Питкэрн",
  "country_of_birth_option_PL": "Польша",
  "country_of_birth_option_PT": "Португалия",
  "country_of_birth_option_PR": "Пуэрто-Рико",
  "country_of_birth_option_QA": "Катар",
  "country_of_birth_option_RE": "Воссоединение",
  "country_of_birth_option_RO": "Румыния",
  "country_of_birth_option_RU": "Русский",
  "country_of_birth_option_RW": "РУАНДА",
  "country_of_birth_option_SH": "Святой Елена",
  "country_of_birth_option_KN": "Сент-Китс и Невис",
  "country_of_birth_option_LC": "Сент-Люсия",
  "country_of_birth_option_PM": "Сен-Пьер и Микелон",
  "country_of_birth_option_VC": "Святой Винсент и Гренадины",
  "country_of_birth_option_WS": "Самоа",
  "country_of_birth_option_SM": "Сан-Марино",
  "country_of_birth_option_ST": "Сан-Томе и Принсипи",
  "country_of_birth_option_SA": "Саудовская Аравия",
  "country_of_birth_option_SN": "Сенегал",
  "country_of_birth_option_CS": "Сербия и Черногория",
  "country_of_birth_option_SC": "Сейшельские острова",
  "country_of_birth_option_SL": "Сьерра-Леоне",
  "country_of_birth_option_SG": "Сингапур",
  "country_of_birth_option_SK": "Словакия",
  "country_of_birth_option_SI": "Словения",
  "country_of_birth_option_SB": "Соломоновы острова",
  "country_of_birth_option_SO": "Сомали",
  "country_of_birth_option_ZA": "Южная Африка",
  "country_of_birth_option_GS": "Южная Грузия и Южноэндвич-Острова",
  "country_of_birth_option_ES": "Испания",
  "country_of_birth_option_LK": "Шри-Ланка",
  "country_of_birth_option_SD": "Судан",
  "country_of_birth_option_SR": "Суринама",
  "country_of_birth_option_SJ": "Свальбард и январь Майен",
  "country_of_birth_option_SZ": "Свазиленд",
  "country_of_birth_option_SE": "Швеция",
  "country_of_birth_option_CH": "Швейцария",
  "country_of_birth_option_SY": "Сирийская Арабская Республика",
  "country_of_birth_option_TW": "Тайвань, провинция Китая",
  "country_of_birth_option_TJ": "Таджикистан",
  "country_of_birth_option_TZ": "Танзания, Объединенная Республика",
  "country_of_birth_option_TH": "Таиланд",
  "country_of_birth_option_TL": "Тимор-Лешти",
  "country_of_birth_option_TG": "Идти",
  "country_of_birth_option_TK": "Токелау",
  "country_of_birth_option_TO": "Тонга",
  "country_of_birth_option_TT": "Тринидад и Тобаго",
  "country_of_birth_option_TN": "Тунис",
  "country_of_birth_option_TR": "Турция",
  "country_of_birth_option_TM": "Туркменистан",
  "country_of_birth_option_TC": "Острова Теркс и Кайкос",
  "country_of_birth_option_TV": "Тувалу",
  "country_of_birth_option_UG": "Уганда",
  "country_of_birth_option_UA": "Украина",
  "country_of_birth_option_AE": "Объединенные Арабские Эмираты",
  "country_of_birth_option_GB": "объединенное Королевство",
  "country_of_birth_option_US": "Соединенные Штаты",
  "country_of_birth_option_UM": "Международные отдаленные острова США",
  "country_of_birth_option_UY": "Уругвай",
  "country_of_birth_option_UZ": "Узбекистан",
  "country_of_birth_option_VU": "Вануату",
  "country_of_birth_option_VE": "Венесуэла",
  "country_of_birth_option_VN": "Вьетнам",
  "country_of_birth_option_VG": "Виргинские острова, британский",
  "country_of_birth_option_VI": "Виргинские острова, США.",
  "country_of_birth_option_WF": "Уоллис и Футуна",
  "country_of_birth_option_EH": "Западная Сахара",
  "country_of_birth_option_YE": "Йемен",
  "country_of_birth_option_ZM": "Замбия",
  "country_of_birth_option_ZW": "Зимбабве",
  "gender_option_female": "женский",
  "gender_option_male": "Мужской",
  "gender_option_nonconf": "Пол не соответствует",
  "relationship_status_option_single": "Одинокий",
  "relationship_status_option_domestic_partner": "Сожитель",
  "relationship_status_option_common_law": "Общее право",
  "relationship_status_option_emancipated_minor": "Эмансипированный несовершеннолетний",
  "relationship_status_option_married": "Женатый",
  "relationship_status_option_divorced": "В разводе",
  "relationship_status_option_separated": "Отделен",
  "relationship_status_option_widowed": "Одоверенный",
  "housing_option_own": "Своя",
  "housing_option_room_in_apartment": "Комната в квартире",
  "housing_option_friends_or_family": "Друзья или семья",
  "housing_option_regular_rent": "Регулярная аренда",
  "housing_option_subsidized_rent": "Субсидированная аренда",
  "housing_option_shelter": "Приют",
  "housing_option_homeless": "Бездомный",
  "employment_option_full_time": "На постоянной основе",
  "employment_option_part_time": "Неполная занятость",
  "employment_option_unemployed": "Безработные",
  "education_option_no_high_school": "Нет средней школы",
  "education_option_high_school_diploma": "Диплом средней школы",
  "education_option_ged": "Сороки",
  "education_option_associate_or_bachelo": "Ассоциированные или степень бакалавра",
  "education_option_post_graduate": "Аспирантура",
  "ethnicity_option_two_or_more_races": "Два или более рас",
  "ethnicity_option_black": "Черный (не испанский)",
  "ethnicity_option_white": "Белый (не испанский)",
  "ethnicity_option_hispanic_or_latino": "испанец или латиноамериканец",
  "ethnicity_option_asian_or_pacific": "Азиатский или тихоокеанский островитянин",
  "ethnicity_option_american_indian_or_alaskan": "Американский индийский или Аляскинский",
  "ethnicity_option_other": "Другой",
  "snap_benefits": "Дополнительная программа поддержки питания",
  "wic_benefits": "Дополнительная программа питания для женщин, младенцев и детей",
  "tanf_benefits": "Временная помощь для нуждающихся семей",
  "medicaid_benefits": "Страхование общественного здравоохранения для людей с низким доходом",
  "ssi_benefits": "Дополнительная программа обеспечения безопасности",
  "free_reduced_meals": "Бесплатная или уменьшенная программа еды",
  "tefap_form": "Сертификация Tefap",
  "tefap_form_expired": "Ваша аттестация Tefap истек на",
  "tefap_form_usda_title": "Заявление Министерства сельского хозяйства США о недискриминации",
  "tefap_form_usda_subheader": "Обратите внимание на следующее",
  "tefap_form_usda_body": "<p>В соответствии с федеральным законом о гражданских правах и положениями и политикой в области гражданских прав Министерства сельского хозяйства США (USDA), этому учреждению запрещается дискриминация по признаку расы, цвета кожи, национального происхождения, пола (включая гендерную идентичность и сексуальную ориентацию), инвалидности, возраста, репрессалии или возмездие за предыдущую деятельность в области гражданских прав. Информация о программе может быть предоставлена не только на английском, но и на других языках. Лица с ограниченными возможностями, которым требуются альтернативные средства связи для получения информации о программе (шрифт Брайля, крупный шрифт, аудиозапись, американский язык жестов), должны обратиться в соответствующее штатное или местное агентство, которое управляет программой, или в центр TARGET Министерства сельского хозяйства США по телефону 202-720-2600 (по голосовой и телетайпной связи TTY) или обратитесь в Министерство сельского хозяйства США через Федеральную службу ретрансляции по телефону 800-877-8339.</p><p>Чтобы подать жалобу на дискриминацию в программе, заявитель должен заполнить форму AD-3027, форму жалобы на дискриминацию в программе Министерства сельского хозяйства США, которую можно получить в <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">Интернете</a>, в любом офисе Министерства сельского хозяйства США, позвонив по телефону 866-632-9992 или отправив письмо в Министерства сельского хозяйства США (USDA). Письмо должно содержать имя и фамилию заявителя, адрес, номер телефона и письменное описание предполагаемого дискриминационного действия с достаточной детализацией, чтобы проинформировать помощника секретаря по гражданским правам (ASCR) о характере и дате предполагаемого нарушения гражданских прав. Заполненную форму AD-3027 или письмо необходимо отправить в Министерство сельского хозяйства США:</p><p>по почте: U.S. Department of Agriculture Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Washington, D.C. 20250-9410;</p><p>или по факсу: (833) 256- 1665 или (202) 690-7442;</p><p>или по электронной почте: program.intake@usda.gov</p><p>Это учреждение предоставляет равные возможности.</p>",
  "app_button_next": "Следующий",
  "app_button_back": "Назад",
  "app_button_submit": "Представлять на рассмотрение",
  "app_button_close": "Закрывать",
  "app_button_done": "Готово",
  "form_required": "Необходимый *",
  "benefits": "Программы пособия",
  "benefits_extra": "Подробности о программах пособия",
  "help_and_support": "Мы здесь, чтобы помочь",
  "help_and_support_extra": "ЧАВО и контактная информация",
  "frequently_asked_questions": "Часто задаваемые вопросы",
  "contact_support": "Связаться со службой поддержки",
  "optional_details": "Дополнительные детали",
  "address_street_1": "Адрес",
  "address_street_2": "Доп",
  "city": "Город",
  "state": "Состояние",
  "zipcode": "Почтовый индекс",
  "additional_optional_details": "Дополнительные детали",
  "gender": "Пол",
  "relationship_status": "Семейное положение",
  "ethnicity": "Этническая принадлежность",
  "country_of_birth": "Страна рождения",
  "employment": "Трудоустройство",
  "highest_education_obtained": "Образование",
  "food_preferences": "Настройки продуктов питания",
  "housing_details": "Подробности жилья",
  "housing_status": "Статус жилья",
  "special_circumstances": "Особые обстоятельства",
  "needs_assistance": "Мне нужна помощь в кладовых",
  "dont_need_assistance": "Мне не нужна помощь в кладовых",
  "aiq_validation_error_min_adult_family_members": "Количество взрослых членов семьи должно быть больше 0.",
  "aiq_validation_error_max_adult_family_members": "Количество взрослых членов семьи не может превышать 10.",
  "aiq_validation_error_min_child_family_members": "Количество детей-членов домохозяйства должно быть больше 0",
  "aiq_validation_error_max_child_family_members": "Количество детей-членов домохозяйства не может быть больше 10.",
  "aiq_validation_error_min_senior_family_members": "Количество старших членов семьи должно быть больше 0",
  "aiq_validation_error_max_senior_family_members": "Число старших членов семьи не может превышать 10.",
  "aiq_validation_error_required_emergency_contact": "Требуется срочная контактная информация",
  "aiq_validation_error_required_pick_up_name": "Введите имя представителя",
  "aiq_validation_error_required_birth_date": "Требуется информация о дате рождения",
  "aiq_validation_error_regex_zip_code": "Индекс должен быть числовым",
  "aiq_validation_error_required_first_name": "Требуется имя",
  "aiq_validation_error_required_last_name": "Фамилия обязательна",
  "aiq_validation_error_min_baby_supplies": "Детские принадлежности должны быть больше 0",
  "aiq_validation_error_max_baby_supplies": "Детские принадлежности не могут быть больше 10",
  "dietary_preferences_option_lactose": "Непереносимость лактозы",
  "dietary_preferences_option_gluten": "Нетерпимость глютена",
  "dietary_preferences_option_kosher": "Кошерство",
  "dietary_preferences_option_halal": "Халяль",
  "dietary_preferences_option_dairy_free": "Без молочных продуктов",
  "dietary_preferences_option_vegetarian": "Вегетарианский",
  "dietary_preferences_option_vegan": "Веган",
  "dietary_preferences_option_fodmap": "Fodmap",
  "dietary_preferences_option_nut_allergy": "Гайка дерева и арахиса",
  "dietary_preferences_option_fish_allergy": "Аллергия рыб и моллюской",
  "dietary_preferences_option_none": "Нет предпочтений",
  "tefap_additional_info_requested": "Дополнительная информация Запрошена",
  "tefap_zipcode_correct": "Ваш почтовый индекс правильно?",
  "tefap_address_correct": "Ваш адрес правильный?",
  "tefap_participate_in_programs": "Кто-нибудь в вашем доме участвует в любой из следующих программ?",
  "tefap_check_all_that_apply": "Пожалуйста, выберите все, что подходит. Если нет, нажмите «Далее», чтобы просмотреть дополнительные параметры.",
  "tefap_household_numbers_correct": "Количество людей в вашем доме правильно?",
  "tefap_household_dont_include_yourself": "Пожалуйста, не показывайте себя на этом экране. TEFAP требует только общий размер вашего домохозяйства, но Plentiful отображает информацию, которую вы предоставили ранее.",
  "tefap_income_at_or_below_question": "Ваш доход в или ниже",
  "tefap_for_household_size": "для вашего домохозяйства",
  "tefap_retake_attestation": "Вы хотите вернуть аттестацию?",
  "tefap_attestation_completed": "Вы успешно завершили форму аттестации Tefap.",
  "tefap_thank_you": "Благодарю вас!",
  "tefap_is_recorded": "Ваша аттестация Tefap была записана. Вы можете вернуть его в свой профиль.",
  "tefap_sign_below": "Ваше имя (необязательно)",
  "tefap_legal_signing": "Подписываясь ниже, я заявляю, что мой доход от всех источников не превышает доход, перечисленные выше для домохозяйств, с тем же количеством людей, что и моему домохозяйству, или что моя домохозяйство участвует в программах, которые я проверил эту форму. Я понимаю, что эти записи будут проведены в доверии на этом сайте распространения, но могут быть освобождены в Нью-Йоркский государственный бюро общих услуг или Министерства сельского хозяйства Соединенных Штатов для обзора по их запросу.",
  "tefap_retake": "Приостановка",
  "program_complete_now": "Завершить сейчас",
  "program_complete_later": "Завершить позже",
  "reservation_confirmed": "Посещение подтверждено",
  "tefap_reservation_confirmed": "Ваш визит подтвержден!",
  "pre_registration_confirmed": "Посещение подтверждено",
  "your_upcoming_reservation": "Ваш предстоящий визит",
  "your_upcoming_pre_registration": "Ваш предстоящий визит",
  "tefap_attestation_needed": "Эта кладовая просит вашу аттестацию Tefap.",
  "tefap_attestation_complete_now": "Завершите его сейчас и сэкономьте время на следующем посещении кладовки.",
  "tefap_description": "В рамках Программы чрезвычайной продовольственной помощи (TEFAP) Министерство сельского хозяйства США предоставляет продовольственную поддержку вашему местному сообществу, делая ее доступной для вас через общественные организации, такие как бесплатные столовые и продовольственные кладовые.",
  "tefap_what_is_tefap": "Что такое Tefap?",
  "tefap_confirm_share_with_pantry": "Пожалуйста, подтвердите, что вы хотите поделиться следующей информацией с этой кладовой.",
  "tefap_thanks_for_sharing": "Спасибо за предоставление дополнительной информации, запрошенной кладовой!",
  "tefap_continue_make_reservation": "Продолжить планирование визита",
  "tefap_pantry_is_requesting": "Эта кладовая просит ваш",
  "tefap_missing_information": "Отсутствует информация",
  "tefap_pantry_will_ask": "Нажмите «Далее», чтобы добавить эту информацию сейчас. Если вы пропустите это, кладовая попросит вас ввести ее при следующем посещении.",
  "tefap_submission_pending": "Отправляем ваши ответы в кладовку...",
  "cancel_edit": "Отмена редактирования",
  "edit": "Редактирование",
  "select": "Выбрать",
  "can_prepare_food": "Может подготовить еду",
  "cannot_prepare_food": "Не может подготовить еду",
  "pantry_details_prompt_title": "{{programName}} требуется",
  "pantry_details_prompt_without_visit_label": "Этот продовольственный банк использует {{programName}} для регистрации. У вас будут дополнительные вопросы, на которые нужно ответить, когда вы дойдете до продовольственного банка.",
  "pantry_details_prompt_visit_label": "Этот продовольственный банк использует {{programName}} для регистрации. Ответьте на эти вопросы онлайн, чтобы сэкономить время при следующем посещении.",
  "state_program_attestation_cannot_complete": "Извините, но мы не можем завершить вашу аттестацию в данный момент. Вы можете попробовать еще раз позже, обратиться в службу поддержки или завершить это по прибытии в кладовую.",
  "state_program_attestation_submitted": "Спасибо за завершение аттестации {{programName}}! Ваши ответы были успешно отправлены в кладовую. Это завершение вопросов {{programName}}, и любые дальнейшие запросы исходят от других программ Plentiful.",
  "state_program_cancel_confirmation": "Вы уверены, что хотите отменить аттестацию для {{programName}}? Вам может потребоваться ответить на эти вопросы при посещении кладовой.",
  "state_program_cancel_attestation": "Отменить Аттестацию",
  "state_program_resume_attestation": "Продолжить Аттестацию",
  "tefap_no_submit": "Нет, отправьте",
  "tefap_yes_retake": "Да, возврат",
  "tefap_expires": "Истекает",
  "tefap_incomplete": "Не завершено, завершите сейчас, чтобы сэкономить время при следующем посещении кладовой",
  "tefap_none": "Нет",
  "tefap_benefit_programs_select": "Выберите вашу регистрацию в следующих программах",
  "tefap_pantry_requests_info": "Эта панель запрашивает дополнительную информацию для вашего предстоящего визита.",
  "tefap_eligible": "Вы имеете право",
  "tefap_not_eligible": "Вы не имеете права",
  "tefap_receive_product": "Получить продукцию Tefap",
  "tefap_eligible_program": "Вы участвуете в следующей программе",
  "tefap_eligible_programs": "Вы участвуете в следующих программах",
  "tefap_not_eligible_program": "Вы не участвуете в каких-либо программах",
  "tefap_household_income": "Доход вашего домохозяйства для",
  "tefap_info_changed": "Имеет информацию о приемлемости Tefap (участие в программах пособий, размер домохозяйств и / или доходов) недавно изменилось?",
  "tefap_still_get_food": "Вы все еще можете получить не-TEFAP еду из корма.",
  "tefap_form_checking_here": "Проверяя здесь, вы свидетельствуете о том, что следующее верно:",
  "tefap_form_checking_1": "1. Имя получателя, адрес и размер домашнего домохозяйства, указанные выше.",
  "tefap_form_checking_2_CO": "2. Получатель находится в Колорадо (минимальный срок проживания не требуется).",
  "tefap_form_checking_2_NY": "2. Получатель находится в пределах штата Нью-Йорк (не требуется минимальная длина резидентуры).",
  "tefap_form_checking_3": "3. Получатель встречается вариант 1 и / или вариант 2 руководящих принципов приемности Tefap выше.",
  "tefap_form_checking_4": "4. Эта еда предназначена только для потребления домашнего получателя, и не будет продаваться, торгуется или обмен.",
  "tefap_form_checking_5_1": "5. Получатель осознает свои гражданские права, как описано в",
  "tefap_form_checking_5_2": "Заявление о недискриминации USDA.",
  "tefap_out_of_state": "Вы живете в другом состоянии",
  "and": "и",
  "or": "или",
  "exceeds": "не ниже",
  "not_exceeds": "не превышает",
  "people": "люди",
  "person": "человек",
  "because": "так как",
  "custom_field_first_name": "First Name",
  "custom_field_last_name": "Фамилия",
  "custom_field_contact_info": "Контактная информация",
  "custom_field_birth_date": "День рождения",
  "custom_field_zip_code": "Почтовый индекс",
  "custom_field_household_size": "Размер Houshold.",
  "custom_field_food_pickup": "Представитель пикапа",
  "custom_field_emergency_contact": "Экстренный контакт",
  "custom_field_address": "Адрес",
  "custom_field_needs_assistance": "Особые обстоятельства (нуждается в помощи)",
  "custom_field_benefits_programs": "Преимущества программ",
  "custom_field_tefap_income_eligibility": "Учебность доходов Tefap",
  "custom_field_relationship_status": "Семейное положение",
  "custom_field_ethnicity": "Этническая принадлежность",
  "custom_field_education": "Наибольшее образование получено",
  "custom_field_dietary_preferences": "Диетические настройки",
  "custom_field_gender": "Пол",
  "custom_field_country_of_birth": "Страна рождения",
  "custom_field_employment": "Трудоустройство",
  "custom_field_food_preparation": "Может подготовить еду",
  "custom_field_housing": "Статус жилья",
  "search": "Поиск (Название кладовой, Индекс, Город, Штат)",
  "all": "все",
  "pantry_filter_program_type": "Тип программы",
  "pantry_filter_program_type_non-food": "Непродовольствие",
  "pantry_filter_program_type_foodpantry": "Пища (бесплатные продуктовы)",
  "pantry_filter_program_type_soupkitchen": "Суп-кухонь (бесплатные горячие блюда)",
  "pantry_filter_status": "Статус",
  "pantry_filter_status_all": "Все",
  "pantry_filter_status_opennow": "Открыть сейчас",
  "pantry_filter_status_opentoday": "Открыть сегодня",
  "pantry_filter_status_openthisweek": "Открыть на этой неделе",
  "pantry_filter_status_other": "Другой",
  "pantry_filter_pantry_type": "Тип панели",
  "pantry_filter_pantry_type_plentifulpantry": "Множественная подкормка",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "Подверженная панель партнера",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "Непроверенная панель партнера",
  "search_no_results_found": "Результаты не найдены",
  "search_no_pantries_match": "Нет кладовых, соответствующих \"{query}\"",
  "search_try_searching_by": "Попробуйте искать по:",
  "search_suggestion_city": "Название города (например, \"Бруклин\")",
  "search_suggestion_city_accessibility": "Название города, например, Бруклин",
  "search_suggestion_zipcode": "Почтовый индекс (например, \"10001\")",
  "search_suggestion_zipcode_accessibility": "Почтовый индекс, например, 10001",
  "search_suggestion_pantry_name": "Название кладовой",
  "search_suggestion_street_address": "Адрес улицы",
  "search_accessibility_no_results": "Результаты для {query} не найдены. Попробуйте искать по названию города, почтовому индексу, названию кладовой или адресу улицы.",
  "search_accessibility_no_results_generic": "Результаты не найдены. Попробуйте искать по названию города, почтовому индексу, названию кладовой или адресу улицы.",
  "search_error_unable_to_display": "Не удается отобразить результаты поиска",
  "search_error_occurred": "Произошла ошибка при отображении результатов поиска. Пожалуйста, попробуйте поискать снова.",
  "accessibility_phone": "Телефон: {phone}",
  "accessibility_email": "Электронная почта: {email}",
  "accessibility_website": "Веб-сайт: {website}",
  "pantry_filter_service_type": "Тип сервиса",
  "pantry_filter_service_type_line": "По строкам",
  "pantry_filter_service_type_pre-registration": "Предварительная регистрация",
  "pantry_filter_service_type_qr-code": "QR-код чекин",
  "pantry_filter_service_type_reservation": "Бронирование",
  "program_type_benefit_enrollment": "Пособие по зачислению",
  "program_type_emergency_services": "Службы спасения",
  "program_type_non_plentiful_pantry": "Неудовлетворенная кладовая",
  "program_type_other_services": "Другие услуги",
  "program_type_plentiful_pantry": "Множественная подкормка",
  "program_type_shelter": "Приют",
  "program_type_soup_kitchen": "Суп-кухонь",
  "service_restriction_none": "Без ограничений",
  "service_restriction_seniors": "Только пожилые люди",
  "service_restriction_families_with_children": "Семьи только с детьми",
  "service_restriction_new_clients": "Только новые клиенты",
  "service_restriction_existing_clients": "Только существующие клиенты",
  "filter_by_category": "Фильтр по категории",
  "opted_out": "Кажется, что ваш номер телефона выбирает SMS, поэтому мы не можем отправить вам ваш код входа в систему. Пожалуйста, введите текст START до 726879, а затем попробуйте еще раз",
  "miles_away_singular": "%s миля отсюда",
  "miles_away_plural": "в %s милях отсюда",
  "today": "сегодня",
  "address_autocomplete_placeholder": "Начните вводить текст, чтобы увидеть предложения",
  "push_notification_permissions_denied": "Разрешения не предоставлены для push-уведомлений. Откройте настройки системы и включите push-уведомления.",
  "push_notification_setup_error": "Произошла ошибка при настройке push-уведомлений.",
  "push_notification_alternate_notifications": "Вы по-прежнему будете получать уведомления по SMS или электронной почте.",
  "loading_message": "Поиск продовольственных пунктов рядом с вами",
  "location_services_no_access": "Похоже, у Plentiful нет доступа к данным о местоположении вашего устройства. Включите службы определения местоположения для Plentiful в настройках браузера или устройства.",
  "error_screen_header": "Упс! Что-то пошло не так.",
  "error_screen_message": "У нас возникла непредвиденная проблема. Вы можете попробовать перезапустить приложение или обратиться в службу поддержки.",
  "restart_app": "Перезапустить приложение",
  "email_support": "Поддержка по электронной почте",
  "map_zoom_to_see_all": "Увеличьте масштаб, чтобы увидеть все местоположения",
  "program_eligible": "Вы имеете право на участие в программе {{program}}.",
  "program_ineligible": "Вы не имеете права участвовать в программе {{program}}: {{reason}}",
  "program_not_applicable": "Вы завершили {{program}}.",
  "program_completed": "Вы ответили на все вопросы {{program}}.",
  "program_unknown_eligibility": "TСпасибо за заполнение формы. Поставщик услуг определит ваше право на получение услуги по прибытии."
}
